import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/Icons/a_check--green.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-7f59c0c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "identification",
  class: "identification"
}
const _hoisted_2 = { class: "identification_wrapper" }
const _hoisted_3 = { class: "identification_first_lvl identification_lvls" }
const _hoisted_4 = { class: "form_box__title" }
const _hoisted_5 = { class: "form_box__title_first_level" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "form_box" }
const _hoisted_8 = {
  action: "",
  class: "main_form"
}
const _hoisted_9 = { class: "field_wrapper" }
const _hoisted_10 = { class: "field_box" }
const _hoisted_11 = { class: "field form-group" }
const _hoisted_12 = { class: "field form-group" }
const _hoisted_13 = { class: "field form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$localization.getTranslate("Level")) + " 1 ", 1),
          _hoisted_6,
          _createElementVNode("span", null, "  " + _toDisplayString(_ctx.$localization.getTranslate("Confirmed")), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ui_input, {
                    modelValue: _ctx.NumberPassport,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.NumberPassport) = $event)),
                    headerText: _ctx.$localization.getTranslate('PassportID'),
                    readOnly: ""
                  }, null, 8, ["modelValue", "headerText"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_ui_input, {
                    modelValue: _ctx.scanThePassport,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scanThePassport) = $event)),
                    headerText: _ctx.$localization.getTranslate('ScanThePassport'),
                    readOnly: ""
                  }, null, 8, ["modelValue", "headerText"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_ui_input, {
                    modelValue: _ctx.scanningAccountForUtilities,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.scanningAccountForUtilities) = $event)),
                    headerText: 
											_ctx.$localization.getTranslate('ScanningAccountForUtilities')
										,
                    readOnly: ""
                  }, null, 8, ["modelValue", "headerText"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}